import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EditUserDto } from '../model/edituserdto';
import { ReturnObject } from '../model/returnobject';
import { APIService } from './api.service';
import { User } from '../model/user';
import { BatchJobStatusItem } from '../model/batchjobstatusitem';

@Injectable({
  providedIn: 'root'
})
export class SysadminServiceService {

  constructor(private api: APIService) {
  }

  getAssignmentNumbersWithDispensation(): Observable<ReturnObject<string[]>> {
    return this.api.getAPI(`sysadmin/getdispensationassignments`);
  }

  giveDispensation(assignmentNumber: string): Observable<ReturnObject<string>> {
    return this.api.putAPI(`sysadmin/givedispensation`, JSON.stringify(assignmentNumber));
  }

  removeDispensation(assignmentNumber: string): Observable<ReturnObject<string>> {
    return this.api.putAPI(`sysadmin/removedispensation`, JSON.stringify(assignmentNumber));
  }

  getAllManuallyAddedRoles(): Observable<ReturnObject<EditUserDto[]>> {
    return this.api.getAPI(`sysadmin/getallmanuallyaddedroles`)
  }

  removeRole(globalId: string): Observable<ReturnObject<string>> {
    return this.api.putAPI(`sysadmin/removerole`, JSON.stringify(globalId))
  }

  addRole(newRole: EditUserDto): Observable<ReturnObject<string>> {
    return this.api.postAPI(`sysadmin/addrole`, newRole);
  }

  actAsUser(emulateEmail: string): Observable<ReturnObject<User>> {
    return this.api.getAPI(`sysadmin/actasuser/${encodeURIComponent(emulateEmail)}`);
  }

  stopActAsUser(): Observable<ReturnObject<User>> {
    return this.api.getAPI(`sysadmin/endactasuser`);
  }

  getEmailBatchJobStatus(): Observable<ReturnObject<BatchJobStatusItem[]>> {
    return this.api.getAPI(`sysadmin/getemailbatchjobstatus`)
  }

  getImportBatchJobStatus(): Observable<ReturnObject<BatchJobStatusItem[]>> {
    return this.api.getAPI(`sysadmin/getimportbatchjobstatus`)
  }
}
